import { createContext } from 'react';

import { SharedUserProfile } from './types/SharedUserProfile';

interface SharedAuthContextType {
  profile: SharedUserProfile | undefined;
  setProfile: React.Dispatch<React.SetStateAction<SharedUserProfile | undefined>>;
  isLoading: boolean;
}

export const SharedAuthContext = createContext<SharedAuthContextType | undefined>(undefined);
